import { Action } from 'redux';
import { AddonService } from 'types/AddonService';

export const ADDON_SERVICES_RESET_ACTION_TYPE = 'addonServices/reset';
export const ADDON_SERVICES_ERROR_ACTION_TYPE = 'addonServices/error';

export const ADDON_SERVICES_FETCH_ACTION_TYPE = 'addonServices/fetch_start';
export const ADDON_SERVICES_FETCH_SUCCESS_ACTION_TYPE = 'addonServices/fetch_success';

interface AddonServicesResetAction extends Action<typeof ADDON_SERVICES_RESET_ACTION_TYPE> {}

interface AddonServicesFetchAction extends Action<typeof ADDON_SERVICES_FETCH_ACTION_TYPE> {}
interface AddonServicesFetchSuccessAction
    extends Action<typeof ADDON_SERVICES_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        addonServices: Array<AddonService>;
    };
}

interface AddonServicesErrorAction extends Action<typeof ADDON_SERVICES_ERROR_ACTION_TYPE> {}

export type AddonServicesAction =
    | AddonServicesResetAction
    | AddonServicesFetchAction
    | AddonServicesFetchSuccessAction
    | AddonServicesErrorAction;
